// INFO: During the tests, redux appear to be mutating the initialState
// so we need to create a fresh copy of it whenever we need the to test
// something that relies on the store.
export var createInitialState = function() {
    return {
        activities: [],
        alerts: {
            history: [],
            currentAlert: null
        },
        api: null,
        bonusMaterial: [],
        cbook: null,
        claims: {},
        communityChartData: {},
        completeable: true,
        completed: [],
        connections: {},
        contents: {},
        currentSlide: null,
        debugMessages: [],
        errors: [],
        exam: null,
        examData: {},
        examInteractions: {},
        favorites: [],
        intl: {
            locale: "en",
            messages: {}
        },
        groups: {
            groups: [],
            noteGroup: null
        },
        keyValueStore: {},
        lastVisitedSlide: null,
        loading: [],
        media: {
            activeSubtitleId: undefined,
            preferredSubtitleLang: "unset",
            duration: 0,
            isMute: false,
            isFinished: false,
            isPlaying: false,
            neverPlayed: true,
            volume: 50,
            elapsedTime: 0,
            isFullscreen: false,
            bufferingMediaIds: []
        },
        nodes: [],
        notes: {
            notes: {},
            printNotes: []
        },
        notifications: [],
        originSlide: null,
        quickFavOriginSlide: null,
        ratings: {},
        search: {},
        searchableSlides: [],
        session: null,
        socialChartData: {},
        socialConfig: null,
        storyMode: true,
        student: null,
        topics: {
            allTopics: {},
            currentTopicId: null,
            currentSearch: {
                searchId: undefined,
                topic: null,
                app: "Activity"
            },
            searchResult: {
                topics: []
            }
        },
        uiVisibilityState: {
            accessibilityToolbar: false,
            notes: false,
            menu: false,
            bonusMaterial: false,
            navigation: true,
            activityCenter: false,
            quickNav: false,
            print: false,
            modal: false,
            favOnly: false,
            debug: false,
            quickFavourites: false
        },
        users: [],
        userAvatars: {}
    };
};
var initialState = createInitialState();
export default initialState;
